import apiClient from '../utils/apiClient';
import { PortalFileDto, PortalFolderDto, TypeDto } from "../types/Folder";

export const getFolderDetails = async (typeDto : TypeDto): Promise<PortalFolderDto> => {
    const response = await apiClient.get<PortalFolderDto>(`/portal/folder-by-id/${typeDto.typeId}/${typeDto.userId}`);
    return response.data;
  };
  
  export const getFileDetails = async (typeDto : TypeDto): Promise<PortalFileDto> => {
    const response = await apiClient.get<PortalFileDto>(`/portal/file-by-id/${typeDto.typeId}/${typeDto.userId}`);
    return response.data;
  };